import { render, staticRenderFns } from "./pointsLeafInactive.vue?vue&type=template&id=8436ce8c&"
import script from "./pointsLeafInactive.vue?vue&type=script&lang=js&"
export * from "./pointsLeafInactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports